import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function Terms() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <div style={{ padding: "2rem" }}>
            <Link to="/" className="safe-top-link">
    ← Home
</Link>

            <h1>Terms of Use</h1>

            <p>
                Welcome to Figure It Out. By using this
                website, you agree to these Terms of Use.
                If you do not agree with these terms,
                please do not use the platform.
            </p>

            <h2>Educational Purpose</h2>

            <p>
                Figure It Out is provided for educational
                and personal development purposes only.
                The activities are designed to help users
                practise thinking skills and should not be
                regarded as professional advice.
            </p>

            <h2>Artificial Intelligence</h2>

            <p>
                Some activities use artificial intelligence
                (AI) to generate personalised feedback.
                AI responses may be inaccurate,
                incomplete or inappropriate. You should
                not rely on AI-generated content when
                making important personal, financial,
                educational, legal or medical decisions.
            </p>

            <h2>No Professional Advice</h2>

            <p>
                Nothing on Figure It Out constitutes
                professional, legal, medical,
                psychological, financial or educational
                advice. Where appropriate, users should
                seek advice from a suitably qualified
                professional.
            </p>

            <h2>Limitation of Liability</h2>

            <p>
                Figure It Out is provided "as is" without
                warranties of any kind. To the fullest
                extent permitted by law, the developer
                accepts no responsibility or liability for
                any loss, damage or decisions arising
                from the use of this website or from
                AI-generated responses.
            </p>

            <h2>Acceptable Use</h2>

            <p>
                You agree not to misuse the platform,
                interfere with its operation, attempt to
                gain unauthorised access, or use it for
                unlawful purposes.
            </p>

            <h2>Age Requirement</h2>

            <p>
                Figure It Out is not intended for use by
                children under 13 years of age. If you are
                under 13, please do not use this website.
            </p>

            <h2>Intellectual Property</h2>

            <p>
                Unless otherwise stated, the content,
                activities, software, text, graphics and
                design of Figure It Out are protected by
                copyright and other intellectual property
                laws. They may not be copied,
                redistributed or reproduced without
                permission except where permitted by
                law.
            </p>

            <h2>Changes</h2>

            <p>
                Figure It Out may be updated, modified,
                suspended or discontinued at any time
                without notice. These Terms of Use may
                also be revised from time to time.
            </p>

            <h2>Contact</h2>

            <p>
                If you have questions about these Terms
                of Use, please contact the developer
                using the contact details provided on
                this website.
            </p>
        </div>
    );
}
